import { Outlet } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import logoImage from '@/assets/logo.png'
import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'

// Minimal chrome for Otto-only operators: no sidebar, no BR navigation —
// just the brand, the account name, sign-out, and the portal content.
export function OttoLayout() {
  const { account, signOut } = useAuth()

  return (
    <div className="min-h-screen bg-muted/50">
      <header className="flex items-center justify-between border-b bg-background px-6 py-4">
        <div className="flex items-center gap-3">
          <img src={logoImage} alt="Booked Rides" className="h-8 w-auto" />
          <div>
            <p className="text-sm font-semibold leading-none">Otto AI</p>
            {account && <p className="text-xs text-muted-foreground">{account.name}</p>}
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={() => signOut()}>
          <LogOut className="mr-2 h-4 w-4" /> Sign out
        </Button>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-10">
        <Outlet />
      </main>
    </div>
  )
}
